module.exports = __webpack_public_path__ + "img/expense-icon.d351b598.svg";